import { render, staticRenderFns } from "./TableButtonsEdit.vue?vue&type=template&id=604d1e40&scoped=true&"
import script from "./TableButtonsEdit.vue?vue&type=script&lang=js&"
export * from "./TableButtonsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d1e40",
  null
  
)

export default component.exports